import { createContext, useContext, useEffect, useState } from "react";
import { useARC } from "providers/ARC/ARCProvider";

export const TempMissionContext = createContext();
TempMissionContext.displayName = "TempMission";
export const useTempMission = () => useContext(TempMissionContext);

const TempMissionProvider = ({ children }) => {
    const { selectedARC } = useARC();
    const [waypoints, setWaypoints] = useState([]);
    const [showWaypointsPanel, setShowWaypointsPanel] = useState(false);
    const [isMissionRunning, setIsMissionRunning] = useState(false);

    // Load waypoints from localStorage on mount or when ARC changes
    useEffect(() => {
        if (!selectedARC?.serialNumber) {
            setWaypoints([]);
            return;
        }

        const storageKey = `arc_temp_mission_${selectedARC.serialNumber}`;
        const stored = localStorage.getItem(storageKey);
        if (stored) {
            try {
                setWaypoints(JSON.parse(stored));
            } catch (error) {
                console.error("Error loading waypoints from localStorage:", error);
                setWaypoints([]);
            }
        } else {
            setWaypoints([]);
        }
    }, [selectedARC?.serialNumber]);

    // Save waypoints to localStorage whenever they change
    useEffect(() => {
        if (!selectedARC?.serialNumber) return;

        const storageKey = `arc_temp_mission_${selectedARC.serialNumber}`;
        localStorage.setItem(storageKey, JSON.stringify(waypoints));
    }, [waypoints, selectedARC?.serialNumber]);

    // Add a new waypoint
    const addWaypoint = (goalPose) => {
        const newWaypoint = {
            ...goalPose,
            id: Date.now()
        };
        setWaypoints(prev => [...prev, newWaypoint]);
    };

    // Update existing waypoint
    const updateWaypoint = (id, updates) => {
        setWaypoints(prev =>
            prev.map(w => w.id === id ? { ...w, ...updates } : w)
        );
    };

    // Delete waypoint
    const deleteWaypoint = (id) => {
        setWaypoints(prev => prev.filter(w => w.id !== id));
    };

    // Clear all waypoints
    const clearWaypoints = () => {
        setWaypoints([]);
    };

    return (
        <TempMissionContext.Provider
            value={{
                waypoints,
                addWaypoint,
                updateWaypoint,
                deleteWaypoint,
                clearWaypoints,
                showWaypointsPanel,
                setShowWaypointsPanel,
                isMissionRunning,
                setIsMissionRunning
            }}
        >
            {children}
        </TempMissionContext.Provider>
    );
};

export default TempMissionProvider;
